<template>
  <div id="root">
    <tn-layout :top-index="1000">
      <top-header slot="top"></top-header>
      <div class="stance-block"></div>
      <router-view/>
      <bottom-footer  v-if="!this.$root.isFill"></bottom-footer>
    </tn-layout>
  </div>
</template>

<script>
import TnLayout from './components/TnLayout.vue'
import TopHeader from './components/TopHeader.vue'
import BottomFooter from './components/BottomFooter.vue'

export default {
  name: 'Root',
  components: {
    TnLayout, TopHeader, BottomFooter
  }
}
</script>
<style scoped>
  @media all and (max-width: 650px) {
    .stance-block {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/Root.vue